"use client";

import React from "react";
import Image from "next/image";
import step1Icon from "@/assets/applicationSteps/step-1.svg";
import step2Icon from "@/assets/applicationSteps/step-2.svg";
import step3Icon from "@/assets/applicationSteps/step-3.svg";
import step4Icon from "@/assets/applicationSteps/step-4.svg";
import step5Icon from "@/assets/applicationSteps/step-5.svg";

const steps = [
    {
        id: 1,
        color: "#E04C96",
        label: "Step 1",
        title: "Register Yourself",
        points: ["Fill the online application form and pay the application fee of Rs 1,000"],
        icon: step1Icon,
    },
    {
        id: 2,
        color: "#005580",
        label: "Step 2",
        title: "Verify Email",
        points: ["MSAT is a home based online test", "Comprehensive evaluation"],
        icon: step2Icon,
    },
    {
        id: 3,
        color: "#FF8B28",
        label: "Step 3",
        title: "Fill The Form",
        points: [
            "Get your MSAT score and scholarship eligibility",
            "Receive admission offer letter",
        ],
        icon: step3Icon,
    },
    {
        id: 4,
        color: "#1291D4",
        label: "Step 4",
        title: "Pay Application Fee",
        points: ["Pay the one-time admission fee and receive the provisional admission letter"],
        icon: step4Icon,
    },
    {
        id: 5,
        color: "#005580",
        label: "Step 5",
        title: "Submit Application ",
        points: ["Document verification and payment of semester fee"],
        icon: step5Icon,
    },
];

const ApplicationSteps = () => {
    return (
        <section className="w-full bg-white">
            <div>
                <h2
                    className="text-2xl sm:text-[42px] font-bold text-gray-900 mb-1"
                    style={{ fontFamily: "saans-bold" }}
                >
                    Steps to Follow for Application
                </h2>
                <p
                    className="text-base sm:text-[18px] text-[#000000] mb-8"
                    style={{ fontFamily: "saans-regular" }}
                >
                    Take the first step towards a rewarding career
                </p>

                <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-5">
                    {steps.map((step) => {
                        const lightColor = step.color + "33";
                        const strongColor = step.color + "16";

                        return (
                            <div
                                key={step.id}
                                className="group relative overflow-hidden border border-gray-200/60 bg-[linear-gradient(180deg,#FFF6E8_0%,#FFFFFF_100%)] pt-10 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
                            >

                                <div
                                    className="pointer-events-none absolute inset-0 opacity-0 scale-105 transition-all duration-500 group-hover:opacity-100"
                                    style={{
                                        backgroundImage: `linear-gradient(135deg, ${lightColor} 0%, ${strongColor} 60%, #ffffff 100%)`,
                                    }}
                                />

                                <div
                                    className="w-20 h-20 rounded-b-full flex items-center absolute z-10 left-5 top-0 justify-center text-white transition-transform duration-500 group-hover:scale-110"
                                    style={{ backgroundColor: step.color }}
                                >
                                    <Image
                                        src={step.icon}
                                        alt={step.label}
                                        width={30}
                                        height={30}
                                        className="object-contain"
                                    />
                                </div>

                                <div className="relative px-6 py-6 mt-10 space-y-3 z-10">
                                    <span
                                        className="inline-block text-[10px] font-semibold uppercase tracking-wide mb-1 rounded-sm transition-colors duration-300"
                                        style={{
                                            color: step.color,
                                            backgroundColor: lightColor,
                                            padding: "4px 8px",
                                            fontFamily: "saans-regular",
                                        }}
                                    >
                                        {step.label}
                                    </span>

                                    <h3
                                        className="text-[14px] sm:text-[18px] font-semibold  transition-colors duration-300 group-hover:text-[#111827]"
                                        style={{ fontFamily: "saans-bold" }}
                                    >
                                        {step.title}
                                    </h3>

                                </div>

                                <div
                                    className="absolute -top-10 -right-10 h-32 w-32 rounded-full opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-80"
                                    style={{
                                        backgroundImage: `linear-gradient(to bottom right, ${strongColor}, ${step.color})`,
                                    }}
                                />

                                <div
                                    className="absolute bottom-0 left-0 right-0 h-1 origin-left scale-x-0 rounded-full transition-transform duration-500 group-hover:scale-x-100"
                                    style={{
                                        backgroundImage: `linear-gradient(to right, ${step.color}, ${step.color})`,
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ApplicationSteps;
